import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { g as global$1 } from './index.esm-7182addc.js';

const gravityListCss = "";
const GravityListStyle0 = gravityListCss;

const GravityList = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.scrollEnd = createEvent(this, "scrollEnd", 7);
    }
    handleScroll() {
        this.scrollEnd.emit();
    }
    addIntersectionObserver() {
        if ('IntersectionObserver' in global$1.window) {
            this.io = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    this.handleScroll();
                }
            });
            const intersectionElement = this.element.shadowRoot.querySelector('.list>#intersectionTrigger');
            this.io.observe(intersectionElement);
        }
    }
    componentDidLoad() {
        this.addIntersectionObserver();
    }
    render() {
        return (h("div", { key: 'c0978ff27eaa76aa5f67345abcf8d2573ae6e502', class: "list" }, h("slot", { key: '59abdb538bff6cbf82b50b66965d1c26d535df66' }), h("div", { key: '002356a4b9861157a74a2189d237dbb2ae2c26ad', id: "intersectionTrigger" })));
    }
    get element() { return getElement(this); }
};
GravityList.style = GravityListStyle0;

export { GravityList as gravity_list };

//# sourceMappingURL=gravity-list.entry.js.map